import dayjs from 'dayjs';

export type GroupBy = {
  /**
   * @deprecated Use entity/reason instead
   */
  labelID?: boolean;
  source?: boolean;
  language?: boolean;
  metadata?: string;
  reason?: boolean;
  entity?: boolean;
  recordSentiment?: boolean;
  entitySentiment?: boolean;
  predictedOn?: boolean;
  entityCategory?: boolean;
};

export interface AbsoluteTimeRange {
  type: 'absolute';
  startAfter: dayjs.Dayjs;
  endBefore: dayjs.Dayjs;
}

export enum TimeUnit {
  Day = 'day',
  Week = 'week',
  Month = 'month',
  Quarter = 'quarter',
  Year = 'year',
}

export interface LastTimeRange {
  type: 'last';
  unit: TimeUnit;
  value: number;
}

export interface SinceTimeRange {
  type: 'since';
  startAfter: dayjs.Dayjs;
}

export type TimeRange = AbsoluteTimeRange | LastTimeRange | SinceTimeRange;

export enum AggregatePeriod {
  DAY = 1,
  WEEK = 2,
  MONTH = 3,
  QUARTER = 4,
  YEAR = 5,
  STEPS_12 = 6, // deprecate this
}

export const toAggregatePeriodString = (
  aggregatePeriod: AggregatePeriod,
): string => {
  switch (aggregatePeriod) {
    case AggregatePeriod.DAY:
      return 'Daily';
    case AggregatePeriod.WEEK:
      return 'Weekly';
    case AggregatePeriod.MONTH:
      return 'Monthly';
    case AggregatePeriod.QUARTER:
      return 'Quarterly';
    case AggregatePeriod.YEAR:
      return 'Yearly';
  }
  return '';
};

export const toAggregatePeriod = (aggregatePeriod: String): AggregatePeriod => {
  switch (aggregatePeriod) {
    case 'Daily':
      return AggregatePeriod.DAY;
    case 'Weekly':
      return AggregatePeriod.WEEK;
    case 'Monthly':
      return AggregatePeriod.MONTH;
    case 'Quarterly':
      return AggregatePeriod.QUARTER;
    case 'Yearly':
      return AggregatePeriod.YEAR;
  }
  return AggregatePeriod.WEEK;
};
